import React, { PropTypes } from 'react';
import RenderField from '../../../FormTemplate/InputControl';
import { Field } from 'redux-form';
import { Button, Table } from 'react-bootstrap';
import SelectAsync from './../../../FormTemplate/SelectAsync';


class RenderLists extends React.Component {
   componentDidMount() {
      this.props.fields.push({
         item_id: '',
         unit: '',
         price: ''
      });
   }


   render() {
      const { fields, items } = this.props;
      return (
         <div>
            <Table>
               <thead>
               <tr>
                  <th>Items</th>
                  <th>Unit</th>
                  <th>Total</th>
                  <th>##</th>
               </tr>
               </thead>
               <tbody>
               {fields.map((item, index) =>
                  <tr key={index} >
                     <td className="col-md-7" >
                        <Field
                           name={`${item}.inventory_counter_id`}
                           type="text"
                           minimumInput={2}
                           link="purchaseReturns/searchItemByName"
                           component={SelectAsync} />
                     </td>
                     <td>
                        <Field
                           name={`${item}.unit`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td>
                        {items[index].total}
                     </td>
                     <td>
                        {(index > 0) && <Button onClick={() => fields.remove(index)} >remove</Button>}
                     </td>
                  </tr>
               )}
               </tbody>
            </Table>
            <Button onClick={() => fields.push({
               item_id: '',
               unit: '',
               price: ''
            })} >Add Item</Button>
         </div>
      );
   }
}

RenderLists.propTypes = {
   fields: PropTypes.object,
   items: PropTypes.array
};

export default RenderLists;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/PurchaseReturn/Helper/RenderLists.js
 **/